"use client";

import { useCallback, useState } from "react";

/**
 * Copy text to the clipboard and expose a transient `copied` flag for
 * check-mark feedback. `resetAfterMs` controls how long the flag stays up.
 */
export function useCopyFeedback(resetAfterMs: number): {
	readonly copied: boolean;
	readonly copy: (text: string) => Promise<void>;
} {
	const [copied, setCopied] = useState(false);

	const copy = useCallback(
		async (text: string) => {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setTimeout(() => setCopied(false), resetAfterMs);
		},
		[resetAfterMs],
	);

	return { copied, copy };
}
